import React, { useCallback } from "react";
import "./MiniBridgeTab.scss";

import MiniBridgeIcon from "assets/images/miniBridgeIcon.svg";
import LockIcon from "assets/images/DeffenceScreenLock-icon.svg";
import ElipseDisabled from "assets/icons/elipseDisabled.svg";

interface Props {
  data?: any[];
  onPressItem?: (val: any) => void;
  searchData?: any[];
  search?: string;
}

function MiniBridgeTab({ data, onPressItem, searchData, search }: Props) {
  const renderItem = useCallback(
    (item: any, index_item: any) => {
      return (
        <div
          style={{
            flexDirection: "row",
            flexWrap: "wrap",
            flex: 1,
            display: "flex"
          }}
          key={index_item}>
          {item?.map((val: any, index: number) => {
            if (val === null) {
              return (
                <div className="list-item-courses" key={`${index}`} style={{ opacity: 0 }}></div>
              );
            }

            if (!val?.Data?.IsDisplayed) {
              return null;
            }
            const isDisabled = typeof val?.isEnabled === "boolean" && !val?.isEnabled;
            return (
              <div
                className="list-item-courses"
                key={`${val.Data?.Id_Category}_${index}_${val?.Data?.CategoryIndex}`}
                onClick={() => {
                  if (isDisabled) {
                    return;
                  }
                  onPressItem && onPressItem(val);
                }}>
                <div className="MiniBridgeTab-item">
                  <div className="icon-otr-list-icons-courses-wrapper">
                    {isDisabled ? (
                      <div style={{ position: "relative" }}>
                        <div
                          style={{
                            position: "relative",
                            justifyContent: "center",
                            alignItems: "center",
                            display: "flex",
                            background: "none"
                          }}
                          className={"icon-otr list-icons-courses list-icons-courses-disabled"}>
                          <img src={ElipseDisabled} />
                          <img
                            loading="lazy"
                            className="minibridge-icon"
                            style={{ position: "absolute", width: 52, height: 62 }}
                            src={isDisabled ? LockIcon : MiniBridgeIcon}
                            alt="icon"
                          />
                        </div>
                      </div>
                    ) : (
                      <>
                        <div className={"icon-otr list-icons-courses"}>
                          <img
                            className="minibridge-icon"
                            src={MiniBridgeIcon}
                            loading="lazy"
                            alt={`${val.Data?.Id_Category}_${index}_${val?.Data?.CategoryIndex}`}
                          />
                        </div>
                      </>
                    )}
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      flex: 1,
                      width: "100%"
                    }}>
                    <span
                      className="minibridge-icon-text"
                      style={{
                        color: isDisabled ? "rgba(120, 101, 158, 1)" : undefined
                      }}>
                      {val.Data?.CourseTitle}
                    </span>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      );
    },
    [onPressItem]
  );

  if (searchData && searchData?.length > 0) {
    return (
      <div className="MiniBridgeTab-main">
        <div className="MiniBridgeTab-content">
          <div
            style={{
              flexDirection: "row",
              flexWrap: "wrap",
              flex: 1,
              display: "flex"
            }}>
            {searchData.map((val: any, index: number) => {
              if (val === null) {
                return null;
              }
              const isDisabled = typeof val?.isEnabled === "boolean" && !val?.isEnabled;
              return (
                <div
                  className="list-item-courses"
                  key={`${val.Data?.Id_Category}_${index}_${val?.Data?.CategoryIndex}`}
                  onClick={() => !isDisabled && onPressItem && onPressItem(val)}>
                  <div className="MiniBridgeTab-item">
                    {isDisabled ? (
                      <div style={{ position: "relative" }}>
                        <div
                          style={{
                            position: "relative",
                            justifyContent: "center",
                            alignItems: "center",
                            display: "flex",
                            background: "none"
                          }}
                          className={"icon-otr list-icons-courses list-icons-courses-disabled"}>
                          {/*<img src={ElipseDisabled} />*/}
                          <img
                            loading="lazy"
                            className="minibridge-icon"
                            style={{ position: "absolute", width: 52, height: 62 }}
                            src={LockIcon}
                            alt="icon"
                          />
                        </div>
                      </div>
                    ) : (
                      <div className={"icon-otr list-icons-courses"}>
                        <img
                          className="minibridge-icon"
                          src={MiniBridgeIcon}
                          loading="lazy"
                          alt={`${val.Data?.Id_Category}_${index}`}
                        />
                      </div>
                    )}
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        flex: 1,
                        width: "100%"
                      }}>
                      <span
                        className="minibridge-icon-text"
                        style={{
                          color: isDisabled ? "rgba(120, 101, 158, 1)" : undefined
                        }}>
                        {val.Data?.CourseTitle}
                      </span>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="MiniBridgeTab-main">
      <div className="MiniBridgeTab-content">
        {data && data?.length > 0 && data?.map(renderItem)}
      </div>
    </div>
  );
}

export default MiniBridgeTab;
